import { PropsOf, XOR } from "@ugitgud/legos/ui/shared";
import type NextImage from "next/image";
import type { ImageProps as NextImageProps, StaticImageData } from "next/image";
import React from "react";

export type ImageProps = XOR<
  { as?: "img" } & Omit<PropsOf<"img">, "src">,
  { as: typeof NextImage } & Omit<NextImageProps, "src">
>;

export const Image = React.forwardRef(
  <T extends React.ElementType | React.ComponentType<typeof NextImage> = "img">(
    props: ImageProps & { src: string | StaticImageData },
    ref: React.ForwardedRef<React.ElementRef<T>>,
  ) => {
    const { as, src, ...rest } = props;
    const srcProp = typeof src !== "string" ? src.src : src;
    const Component = (as as React.ElementType) || ("img" as React.ElementType);
    return <Component src={srcProp} {...rest} ref={ref} />;
  },
);
